import { CreatedArticle } from "@/includes/types/Articles.types";

export type ArticlesState = {
    articles: Array<CreatedArticle> | null
}

export const articlesState: ArticlesState = {
    articles: null
}
